import { Json } from './Json';
import { UserClient } from '@clearing-hub/common';

export class UserCache {

  user: UserClient;
  selectedAccounts: Array<string>;
  isBitfinexTargetEnabled: Json<string, Json<number, Json<string, boolean>>>;
  isBitfinexSwapTargetEnabled: Json<string, Json<number, Json<string, boolean>>>;

  constructor(isBitfinexTargetEnabled: Json<string, Json<number, Json<string, boolean>>>, user: UserClient, selectedAccounts: Array<string>) {
    this.user = user;
    this.isBitfinexTargetEnabled = isBitfinexTargetEnabled;
    this.selectedAccounts = selectedAccounts;
  }
}
